var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyCartSvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3436_50366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.5924 94.4602C69.8509 96.9597 71.961 98.8204 74.4198 98.8204C74.5869 98.8204 74.7554 98.812 74.9251 98.7945C77.5944 98.5185 79.5348 96.1311 79.2588 93.4618L77.0178 71.7784C76.7418 69.1091 74.353 67.1713 71.685 67.4447C69.0158 67.7207 67.0753 70.1082 67.3513 72.7774L69.5924 94.4602Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.001 98.7945C100.171 98.812 100.339 98.8204 100.506 98.8204C102.966 98.8204 105.075 96.9597 105.334 94.4602L107.574 72.7768C107.85 70.1069 105.91 67.7194 103.241 67.4441C100.569 67.1713 98.1832 69.1091 97.9072 71.7778L95.6668 93.4611C95.3908 96.1311 97.3312 98.5185 100.001 98.7945Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3766 119.916C54.083 119.916 47.3359 126.663 47.3359 134.956C47.3359 143.252 54.083 150.001 62.3766 150.001C70.6701 150.001 77.4178 143.252 77.4178 134.956C77.4178 126.663 70.6701 119.916 62.3766 119.916ZM62.3766 140.282C59.4416 140.282 57.0542 137.892 57.0542 134.955C57.0542 132.021 59.4416 129.633 62.3766 129.633C65.3115 129.633 67.6996 132.021 67.6996 134.955C67.6996 137.892 65.3115 140.282 62.3766 140.282Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.549 119.916C104.256 119.916 97.5078 126.663 97.5078 134.956C97.5078 143.252 104.255 150.001 112.549 150.001C120.843 150.001 127.592 143.252 127.592 134.956C127.592 126.663 120.843 119.916 112.549 119.916ZM112.549 140.282C109.614 140.282 107.226 137.892 107.226 134.955C107.226 132.021 109.614 129.633 112.549 129.633C115.485 129.633 117.873 132.021 117.873 134.955C117.873 137.892 115.485 140.282 112.549 140.282Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.614 51.2346C140.694 50.0445 139.275 49.3474 137.77 49.3474H40.9149L36.8475 33.7068C36.2904 31.5655 34.3571 30.0709 32.1445 30.0709H12.2292C9.54571 30.0709 7.37012 32.2465 7.37012 34.93C7.37012 37.6135 9.54571 39.7891 12.2292 39.7891H28.3875L32.4218 55.3034C32.4419 55.3902 32.4646 55.4763 32.4892 55.5612L47.4923 113.253C48.0494 115.394 49.9827 116.889 52.1953 116.889H122.733C124.945 116.889 126.879 115.394 127.436 113.253L142.473 55.4291C142.852 53.9746 142.534 52.4255 141.614 51.2346ZM118.976 107.172H55.9523L43.4423 59.0663H131.486L118.976 107.172Z",
    fill: "#D7D7D7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3436_50366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCartSvgrepoCom1);
export default __webpack_public_path__ + "static/media/empty-cart-svgrepo-com 1.0fbcb6dccb0c9937123c6e9fb1c6b5a5.svg";
export { ForwardRef as ReactComponent };